/**
 *
 * Schedule - CVent Block
 *
 * Handling CVent schedule
 */

jQuery(document).ready(function () {
    const $ = jQuery;
    const cvent = new CVent();

    const scheduleBlock = $(".itbl-schedule-cvent");
    const eventCode = scheduleBlock.data('event');

    if(!scheduleBlock.length) {
        return;
    }

    if(eventCode) {
        getAndPopulateSessions(eventCode);
    } else {
       return;
    }

    function getAndPopulateSessions(eventCode) {
        cvent.getSessions(eventCode).then(response => {
            const groupedSchedules = [];

            response.forEach(schedule => {
                const date = getDateInLosAngeles(schedule.start);

                if(!groupedSchedules[date]) {
                    groupedSchedules[date] = [];
                }

                groupedSchedules[date].push(schedule);
            });

            populateSchedule(groupedSchedules);
        }).then(() => {
            // Add expand functionality
            $('.itbl-schedule-cvent__expand').on('click', function () {
                $(this).parent().toggleClass('expanded');
            });

            // Add category filter functionality
            $('.itbl-schedule-cvent__category-select').on('change', function () {
                const $scheduleItems = $(this).parent().parent().find('.itbl-single-schedule');
                const selectedCategory = $(this).val();

                $scheduleItems.each(function () {
                    const $scheduleItem = $(this);

                    if(selectedCategory === 'all') {
                        $scheduleItem.show();
                    } else {
                        if($scheduleItem.hasClass('itbl-single-schedule--category-' + selectedCategory)) {
                            $scheduleItem.show();
                        } else {
                            $scheduleItem.hide();
                        }
                    }
                });
            });

            // Add location filter functionality
            $('.itbl-schedule-cvent__location-select').on('change', function () {
                const $scheduleItems = $(this).parent().parent().find('.itbl-single-schedule');
                const selectedLocation = $(this).val();

                $scheduleItems.each(function () {
                    const $scheduleItem = $(this);

                    if(selectedLocation === 'all') {
                        $scheduleItem.show();
                    } else {
                        if($scheduleItem.hasClass('itbl-single-schedule--location-' + selectedLocation)) {
                            $scheduleItem.show();
                        } else {
                            $scheduleItem.hide();
                        }
                    }
                });
            });
        });
    }

    function getDateInLosAngeles(dateIsoString) {
        return moment(dateIsoString)
          .tz("America/Los_Angeles")
          .format('MMMM D, YYYY');
    }

    function getTimeInLosAngeles(timeIsoString) {
        return moment(timeIsoString)
          .tz("America/Los_Angeles")
          .format('h:mm a');
    }

    function populateSchedule(schedules) {
        const $contentWrapper = $('.itbl-schedule-cvent-snippet-wrap');

        for (const formattedDate in schedules) {
            const $singleScheduleWrapper = $(`
                <div class="itbl-schedule-cvent__single-schedule-wrapper"></div>
            `);

            const $date = $(`
                <div class="itbl-schedule-cvent__date-wrapper">
                    <p class="itbl-schedule-cvent__date itbl-u-weight-medium itbl-u-mb-1 itbl-u-mr-1">${formattedDate}</p>
                </div>
            `);

            const $categorySelect = $(`
                <select class="itbl-schedule-cvent__select itbl-schedule-cvent__category-select itbl-u-mr-1">
                    <option value="all">All</option>
                </select>
            `);

            var categoriesCount = 0;

            const $locationSelect = $(`
                <select class="itbl-schedule-cvent__select itbl-schedule-cvent__location-select itbl-u-mr-1">
                    <option value="all">All</option>
                </select>
            `);

            var locationsCount = 0;

            const $scheduleWrapper = $(`
                <div class="itbl-schedule-cvent__schedule-wrapper schedule-items itbl-u-mt-2 itbl-u-mb-2"></div>
            `);

            var scheduleCategories = [];
            var scheduleLocations = [];

            schedules[formattedDate].forEach(schedule => {
                var scheduleTime = getTimeInLosAngeles(schedule.start);
                var scheduleSpeakers = schedule.speakers;
                var scheduleCategory = schedule.category;
                var categoryClean = scheduleCategory ? scheduleCategory.replace(/\s/g, '-').toLowerCase() : '';
                var categoryClass = scheduleCategory ? 'itbl-single-schedule--category-' + categoryClean : '';
                var scheduleLocation = schedule.location;
                var locationClean = scheduleLocation ? scheduleLocation.replace(/\s/g, '-').toLowerCase() : '';
                var locationClass = scheduleLocation ? 'itbl-single-schedule--location-' + locationClean : '';

                if(scheduleCategory && !scheduleCategories.includes(scheduleCategory)) {
                    const $categoryOption = $(`
                        <option value="${categoryClean}">${scheduleCategory}</option>
                    `);
        
                    $categorySelect.append($categoryOption);

                    scheduleCategories.push(scheduleCategory);

                    categoriesCount++;
                }

                if(scheduleLocation && !scheduleLocations.includes(scheduleLocation)) {
                    const $locationOption = $(`
                        <option value="${locationClean}">${scheduleLocation}</option>
                    `);
        
                    $locationSelect.append($locationOption);

                    scheduleLocations.push(scheduleLocation);

                    locationsCount++;
                }

                var $speakersWrapper = $(`
                    <div class="itbl-schedule-cvent__speakers-wrapper itbl-u-mt-1"></div>
                `);

                scheduleSpeakers.forEach(speaker => {
                    var speakerName = speaker.firstName;
                    var speakerLastName = speaker.lastName;
                    var speakerTitle = speaker.title;
                    var speakerCompany = speaker.company;

                    const $speaker = $(`
                        <div class="itbl-schedule-cvent__speaker">
                            By <span class="itbl-schedule-cvent__speaker-name">${speakerName} ${speakerLastName}</span>&nbsp;•
                            <span class="itbl-schedule-cvent__speaker-title">${speakerTitle}</span>,
                            <span class="itbl-schedule-cvent__speaker-company">${speakerCompany}</span>
                        </div>
                    `);

                    $speakersWrapper.append($speaker);
                });

                if(schedule.description.length > 0) {
                    var scheduleDescription = $(`
                        <div class="itbl-schedule-cvent__schedule-description">
                            <p>${schedule.description}</p><br>
                            Location: <b>${scheduleLocation}</b>&nbsp;&nbsp;•&nbsp;&nbsp;Category: <b>${scheduleCategory}</b>
                        </div>
                    `);
                }

                var $scheduleContent = $(`
                    <div class="itbl-schedule-cvent__schedule-content">
                        <div class="itbl-schedule-cvent__schedule-info schedule-title">
                            <h5 class="itbl-schedule-cvent__schedule-title schedule-title">${schedule.title}</h5>
                        </div>
                    </div>
                `);

                if(schedule.description.length > 0) {
                    var $scheduleExpandBtn = $(`
                        <div class="itbl-schedule-cvent__expand schedule-expand-wrap"></div>
                    `);
                }

                var $schedule = $(`
                    <div class="grid-x itbl-schedule-cvent__schedule itbl-single-schedule ${categoryClass} ${locationClass} itbl-u-pt-1 itbl-u-pb-1">
                        <div class="itbl-schedule-cvent__schedule-time time itbl-u-weight-normal">${scheduleTime}</div>
                    </div>
                `);

                $scheduleContent.append($speakersWrapper);
                if(schedule.description.length > 0) {
                    $scheduleContent.append(scheduleDescription);
                }
                $schedule.append($scheduleContent);
                if(schedule.description.length > 0) {
                    $schedule.append($scheduleExpandBtn);
                }
                $scheduleWrapper.append($schedule);

                if(categoriesCount > 0) {
                    $date.append($categorySelect);
                }

                if(locationsCount > 0) {
                    $date.append($locationSelect);
                }
                $singleScheduleWrapper.append($date);
                $singleScheduleWrapper.append($scheduleWrapper);
            });

            $contentWrapper.append($singleScheduleWrapper);
        }
    }
});